// extracted by mini-css-extract-plugin
module.exports = {"nav__link":"nav__link__ZipfH"};